import { XDatePickerDropdownContent } from '@adornis/datetime/x-date-picker-dropdown.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-date-picker-dropdown-content
 */
@customElement('cr-date-picker-dropdown-content')
export class CrDatePickerDropdownContent extends XDatePickerDropdownContent {
  override styles() {
    const superStyles = super.styles();
    delete superStyles[0]?.[':host > cr-basic-card'].boxShadow;
    return [
      ...superStyles,
      {
        ':host > cr-basic-card': {
          transform: `translateY(-10px)`,
          borderRadius: `0 0 ${this.sizes.borderRadiusSecondary} ${this.sizes.borderRadiusSecondary} `,
          boxShadow: `0px 18px 15px 2px ${this.colors.neutral.shade(600)}`,
        },
      },
    ];
  }
}
